module.exports = "/shared/img/fast-coin.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/fast-coin.png
// module id = 436
// module chunks = 13